<template>
<div class="mintSectionBG">
    <b-container v-if="!isMobile()">
        <b-row>
            <b-col cols="6">
                <h2 class="mintTitle">GENESIS VX MINT COMING SOON!</h2>
                <br>
                <button class="clabsButton" @click="directToMint()">MINT</button>
            </b-col>


            <b-col cols="6">
                <img class="walkMint" src="../../assets/VX/mintWalks/baby.gif" alt="">
                <img class="walkMint" src="../../assets/VX/mintWalks/fusion.gif" alt="">
                <img class="walkMint" src="../../assets/VX/mintWalks/genesis.gif" alt="">
                <img class="walkMint" src="../../assets/VX/mintWalks/mutant.gif" alt="">
            </b-col>
        </b-row>
    </b-container>

    <b-container v-if="isMobile()">
      <b-row>
        <b-col cols="12">


          <img class="walkMintMobile" src="../../assets/VX/mintWalks/baby.gif" alt="">
          <img class="walkMintMobile" src="../../assets/VX/mintWalks/fusion.gif" alt="">

          <br><br>
          <h2 class="mintTitle">GENESIS VX MINT!</h2>
          <br><br><button class="clabsButton" @click="directToMint()">MINT</button><br><br>

          <img class="walkMintMobile" src="../../assets/VX/mintWalks/genesis.gif" alt="">
          <img class="walkMintMobile" src="../../assets/VX/mintWalks/mutant.gif" alt="">
        </b-col>
      </b-row>
    </b-container>
</div>
</template>

<script>
export default {
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        directToMint()
        {
          this.$router.push({ name: 'VxMint' })
        }
    }
}
</script>

<style scoped>
.mintSectionBG
{
    background: url("../../assets/VX/mintWalks/mintclaim.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
}
.mintTitle
{
    margin-top: 10vh;
    color: white;
}
.walkMint
{
    margin-top: 10vh;
    height: 150px;
    display: inline-block;
}
.walkMintMobile
{
    margin-top: 5vh;
    height: 175px;
    display: inline-block;
}

.clabsButton {
  align-items: center;
  background-color: white;
  border: 3px solid #82f5eb;
  border-radius: 8px;
  box-sizing: border-box;
  color: #111;
  cursor: pointer;
  font-size: 16px;
  height: 48px;
  justify-content: center;
  line-height: 24px;
  max-width: 100%;
  padding: 0 25px;
  position: relative;
  text-align: center;
  text-decoration: none;
  margin: 0;
  margin-bottom: 10vh;
}

.clabsButton:after {
  background-color: #111;
  border-radius: 8px;
  content: "";
  display: block;
  height: 48px;
  left: 0;
  width: 100%;
  position: absolute;
  top: -2px;
  transform: translate(8px, 8px);
  transition: transform .2s ease-out;
  z-index: -1;
}

.clabsButton:hover:after {
  transform: translate(0, 0);
}

.clabsButton:active {
  background-color: grey;
  outline: 0;
}

.clabsButton:hover {
  outline: 0;
}

@media (min-width: 768px) {
  .clabsButton {
    padding: 0 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Vx/MintSection.vue